import type { ISerialize } from '@/objects/ISerialize';

export class SignalrProductionDisplayDataItemSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrProductionDisplayDataItemSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrProductionDisplayDataItemSubscribeParameters {
        return new SignalrProductionDisplayDataItemSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrProductionDisplayDataItemSubscribeParameters {
        return new SignalrProductionDisplayDataItemSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrProductionDisplayDataItemSubscribeParameters from another instance of SignalrProductionDisplayDataItemSubscribeParameters.
     * @param other The SignalrProductionDisplayDataItemSubscribeParameters you want to clone
     * @returns A cloned SignalrProductionDisplayDataItemSubscribeParameters
     */
    public static FromOther(
        other: SignalrProductionDisplayDataItemSubscribeParameters,
    ): SignalrProductionDisplayDataItemSubscribeParameters {
        return SignalrProductionDisplayDataItemSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrProductionDisplayDataItemSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrProductionDisplayDataItemSubscribeParameters';
}
